module.exports = __webpack_public_path__ + "img/outdoors.ecff8b65.svg";